( function ( ) {
	'use strict';

	/* @ngInject */
	/* eslint-disable max-params */
	/* eslint no-undef:0 */
	/* eslint max-params:0 */
	function ScriptingModeController ( $scope, logger, $modalInstance, moment, updateObs, observation, apiService, $anchorScroll, $location, $timeout, $filter, evidenceService ) {
		/* eslint-enable max-params */
		var self   = this;

		self.title = 'Scripting Mode Controller';

		self.note      = '';
		self.evidences = observation.masterEvidences || [];

		function filterItem ( type ) {
			return function ( item ) {
				return item.type === type;
			};
		}

		function checkEnter ( ev ) {
			if ( ev.keyCode === 13 && !ev.shiftKey ) {
				ev.preventDefault();
				// this to prevent submitting empty string
				if ( self.note !== '' ) {
					self.submitScript();
				}
			}
		}

		function submitScript () {
			self.evidences.push( {
				'id'        : apiService.generateUUID(),
				'type'      : 8,
				'name'      : self.note,
				'scope'     : 'public',
				'timestamp' : moment().format()
			} );

			$timeout( function () {
				angular.element( '.scripting-right' ).scrollTop( angular.element( '.scripting-right' )[ 0 ].scrollHeight );
			} );

			self.evidences  = observation.masterEvidences;
			self.note       = '';
		}

		// this is for closing the script modal
		function hideModal () {
			$modalInstance.close();
		}

		function close () {
			$modalInstance.dismiss();
		}

		function removeHighlight () {
			if ( !self.attachMode ) {
				$scope.$root.$broadcast( 'unselect:script' );
			}
		}

		function checkScripts () {
			var scriptArr = $filter( 'filter' )( self.evidences, filterItem( 8 ) );

			return scriptArr.length === 0;
		}

		self.checkEnter      = checkEnter;
		self.submitScript    = submitScript;
		self.hideModal       = hideModal;
		self.close           = close;
		self.removeHighlight = removeHighlight;
		self.checkScripts    = checkScripts;

		$scope.$on( 'deleteNote', function ( ev, note ) {
			evidenceService.editDeleteEvidence( note, 'delete', observation );
		} );

		$scope.$on( 'update:script', function () {
			updateObs();
		} );

		function activate () {
			self.delDisable = false;
			logger.info( 'Activated Scripting Mode Controller' );
			self.attachMode    = false;
			self.treeView      = true;
			$scope.observation = observation;
		}

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'ScriptingModeController', ScriptingModeController );

	ScriptingModeController.$inject = [ '$scope', 'logger', '$modalInstance', 'moment', 'updateObs', 'observation', 'apiService', '$anchorScroll', '$location', '$timeout', '$filter', 'evidenceService' ];
} )( );
